import { StyleProps } from '@chakra-ui/react';
import { SimpleGrid, VStack, Heading, Body } from '@hover/blueprint';
import React from 'react';
import { ABOUT_HOVER_STATISTICS } from '../../../constants';
import { IHoverStatistics } from '../../../interfaces/IHoverStatistics';

const bodyStyles: StyleProps = {
  textTransform: 'uppercase',
  letterSpacing: '1px',
  textAlign: { base: 'center', desktop: 'left' },
  maxW: { base: '140px', desktop: '400px' },
};

const Statistic: React.FC = () => (
  <SimpleGrid
    columns={{ base: 2, tablet: 4 }}
    mt={{ base: 400, tablet: 1000 }}
    pb={500}
  >
    {ABOUT_HOVER_STATISTICS.map((item: IHoverStatistics) => (
      <VStack
        key={item.title}
        alignItems={{ base: 'center', desktop: 'flex-start' }}
        mb={{ base: 600, tablet: 0 }}
      >
        <Heading
          as="p"
          color={{ base: 'green.500', tablet: 'green.500' }}
          fontWeight={{ base: 700, tablet: 700 }}
          style={{ marginBottom: 0 }}
          size={{ base: 600, tablet: 700, desktop: 800 }}
        >
          {item.value}
        </Heading>
        <Body size={500} {...bodyStyles}>
          {item.title}
        </Body>
      </VStack>
    ))}
  </SimpleGrid>
);

export default Statistic;
